var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomRetirement = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.462 26.647-4.407-4.404c-4.922-4.92-10.828-5.154-13.782-4.873l6.141-6.137a1.957 1.957 0 0 0 .422-2.062A1.887 1.887 0 0 0 58.102 8h-9.048a10.93 10.93 0 0 0-9.047 4.779A10.93 10.93 0 0 0 30.96 8h-9.047a1.887 1.887 0 0 0-1.313 3.233l6.14 6.137c-3-.328-8.859-.046-13.781 4.873l-4.406 4.404a1.957 1.957 0 0 0-.422 2.062 1.887 1.887 0 0 0 1.734 1.17H22.71c-1.734 1.969-2.672 4.499-2.672 7.17v9.042c0 .75.47 1.452 1.172 1.733.657.281 1.454.188 2.063-.421L37.382 33.3l-5.016 34.952h-6.422a1.88 1.88 0 0 0-1.875 1.874A1.88 1.88 0 0 0 25.944 72h28.08a1.88 1.88 0 0 0 1.875-1.874 1.88 1.88 0 0 0-1.876-1.874h-6.422L42.585 33.3l14.11 14.103c.563.562 1.407.656 2.063.421a1.886 1.886 0 0 0 1.172-1.733v-9.043c0-2.67-.938-5.153-2.672-7.168h12.844c.75 0 1.453-.469 1.735-1.171.328-.703.14-1.5-.375-2.062z",
    fill: "#0F1434",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomRetirement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-retirement.963e120feb07e402b8d04f61bdeb368b.svg";